var exports = {
  "container": "x7be19a29--f5350a--container",
  "offer": "x7be19a29--f5350a--offer",
  "block": "x7be19a29--f5350a--block",
  "image": "x7be19a29--f5350a--image",
  "similar": "x7be19a29--f5350a--similar",
  "text": "x7be19a29--f5350a--text",
};

module.exports = exports;
